import { useReducedMotion } from 'framer-motion';
import type { Transition, Variants } from 'framer-motion';

export const easeOut: Transition = { duration: 0.2, ease: [0.16, 1, 0.3, 1] };

export const springSoft: Transition = {
  type: 'spring',
  stiffness: 300,
  damping: 28,
  mass: 0.8,
};

export const fadeSlideUp: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: easeOut },
  exit: { opacity: 0, y: -4, transition: { duration: 0.12 } },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: easeOut },
  exit: { opacity: 0, transition: { duration: 0.12 } },
};

export const staggerContainer: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05, delayChildren: 0.04 } },
};

export const bottomSheetVariants: Variants = {
  hidden: { y: '100%', opacity: 0 },
  visible: { y: 0, opacity: 1, transition: springSoft },
  exit: { y: '100%', opacity: 0, transition: { duration: 0.18 } },
};

export const dialogVariants: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: { opacity: 1, scale: 1, transition: easeOut },
  exit: { opacity: 0, scale: 0.98, transition: { duration: 0.12 } },
};

export const pageTransitionVariants: Variants = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.15 } },
  exit: { opacity: 0, y: -8, transition: { duration: 0.15 } },
};

export const slideOverVariants: Variants = {
  hidden: { x: '100%', opacity: 0 },
  visible: { x: 0, opacity: 1, transition: springSoft },
  exit: { x: '100%', opacity: 0, transition: { duration: 0.18 } },
};

/**
 * Returns variants that snap instantly when user prefers reduced motion.
 * When reduced motion is active, all keys collapse to duration:0 so
 * framer-motion still runs the state machine but with no perceived animation.
 */
export function useSnapVariants(variants: Variants): Variants {
  const reduced = useReducedMotion();
  if (!reduced) return variants;
  const snapped: Variants = {};
  for (const key of Object.keys(variants)) {
    snapped[key] = { ...variants[key], transition: { duration: 0 } };
  }
  return snapped;
}
